<template>
</template>
<script>
import useStore from 'webmd-cms-store/src/store';


import _has from 'lodash/has';

const fonts = {
	'Playfair+Display': {
		font: 'https://fonts.gstatic.com/s/playfairdisplay/v25/nuFiD-vYSZviVYUb_rj3ij__anPXDTzYgA.woff2',
		'font-face': "@font-face{font-family:'Playfair Display';font-style:normal;font-weight:900;font-display:optional;src:url(https://fonts.gstatic.com/s/playfairdisplay/v25/nuFiD-vYSZviVYUb_rj3ij__anPXDTzYgA.woff2) format('woff2');unicode-range:U+0000-00FF,U+0131,U+0152-0153,U+02BB-02BC,U+02C6,U+02DA,U+02DC,U+2000-206F,U+2074,U+20AC,U+2122,U+2191,U+2193,U+2212,U+2215,U+FEFF,U+FFFD}@font-face{font-family:'Playfair Display';font-style:normal;font-weight:700;font-display:optional;src:url(https://fonts.gstatic.com/s/playfairdisplay/v25/nuFiD-vYSZviVYUb_rj3ij__anPXDTzYgA.woff2) format('woff2');unicode-range:U+0000-00FF,U+0131,U+0152-0153,U+02BB-02BC,U+02C6,U+02DA,U+02DC,U+2000-206F,U+2074,U+20AC,U+2122,U+2191,U+2193,U+2212,U+2215,U+FEFF,U+FFFD}@font-face{font-family:'Playfair Display';font-style:normal;font-weight:400;font-display:optional;src:url(https://fonts.gstatic.com/s/playfairdisplay/v25/nuFiD-vYSZviVYUb_rj3ij__anPXDTzYgA.woff2) format('woff2');unicode-range:U+0000-00FF,U+0131,U+0152-0153,U+02BB-02BC,U+02C6,U+02DA,U+02DC,U+2000-206F,U+2074,U+20AC,U+2122,U+2191,U+2193,U+2212,U+2215,U+FEFF,U+FFFD}",
	},
	Poppins: {
		font: 'https://fonts.gstatic.com/s/poppins/v15/pxiByp8kv8JHgFVrLBT5Z1xlFQ.woff2,https://fonts.gstatic.com/s/poppins/v15/pxiByp8kv8JHgFVrLCz7Z1xlFQ.woff2,https://fonts.gstatic.com/s/poppins/v19/pxiByp8kv8JHgFVrLDz8Z1xlFQ.woff2,https://fonts.gstatic.com/s/poppins/v19/pxiByp8kv8JHgFVrLGT9Z1xlFQ.woff2',
		'font-face': "@font-face{font-family:Poppins;font-style:normal;font-weight:900;font-display:optional;src:url(https://fonts.gstatic.com/s/poppins/v15/pxiByp8kv8JHgFVrLBT5Z1xlFQ.woff2) format('woff2');unicode-range:U+0000-00FF,U+0131,U+0152-0153,U+02BB-02BC,U+02C6,U+02DA,U+02DC,U+2000-206F,U+2074,U+20AC,U+2122,U+2191,U+2193,U+2212,U+2215,U+FEFF,U+FFFD}@font-face{font-family:Poppins;font-style:normal;font-weight:700;font-display:optional;src:url(https://fonts.gstatic.com/s/poppins/v15/pxiByp8kv8JHgFVrLCz7Z1xlFQ.woff2) format('woff2');unicode-range:U+0000-00FF,U+0131,U+0152-0153,U+02BB-02BC,U+02C6,U+02DA,U+02DC,U+2000-206F,U+2074,U+20AC,U+2122,U+2191,U+2193,U+2212,U+2215,U+FEFF,U+FFFD}@font-face{font-family:Poppins;font-style:normal;font-weight:300;font-display:optional;src:url(https://fonts.gstatic.com/s/poppins/v19/pxiByp8kv8JHgFVrLDz8Z1xlFQ.woff2) format('woff2');unicode-range:U+0000-00FF,U+0131,U+0152-0153,U+02BB-02BC,U+02C6,U+02DA,U+02DC,U+2000-206F,U+2074,U+20AC,U+2122,U+2191,U+2193,U+2212,U+2215,U+FEFF,U+FFFD}@font-face{font-family:Poppins;font-style:normal;font-weight:500;font-display:optional;src:url(https://fonts.gstatic.com/s/poppins/v19/pxiByp8kv8JHgFVrLGT9Z1xlFQ.woff2) format('woff2');unicode-range:U+0000-00FF,U+0131,U+0152-0153,U+02BB-02BC,U+02C6,U+02DA,U+02DC,U+2000-206F,U+2074,U+20AC,U+2122,U+2191,U+2193,U+2212,U+2215,U+FEFF,U+FFFD}",
	},
	Nunito: {
		font: 'https://fonts.gstatic.com/s/nunito/v20/XRXV3I6Li01BKofINeaB.woff2',
		'font-face': "@font-face{font-family:Nunito;font-style:normal;font-weight:300;font-display:optional;src:url(https://fonts.gstatic.com/s/nunito/v20/XRXV3I6Li01BKofINeaB.woff2) format('woff2');unicode-range:U+0000-00FF,U+0131,U+0152-0153,U+02BB-02BC,U+02C6,U+02DA,U+02DC,U+2000-206F,U+2074,U+20AC,U+2122,U+2191,U+2193,U+2212,U+2215,U+FEFF,U+FFFD}@font-face{font-family:Nunito;font-style:normal;font-weight:700;font-display:optional;src:url(https://fonts.gstatic.com/s/nunito/v20/XRXV3I6Li01BKofINeaB.woff2) format('woff2');unicode-range:U+0000-00FF,U+0131,U+0152-0153,U+02BB-02BC,U+02C6,U+02DA,U+02DC,U+2000-206F,U+2074,U+20AC,U+2122,U+2191,U+2193,U+2212,U+2215,U+FEFF,U+FFFD}",
	},
	Oswald: {
		font: 'https://fonts.gstatic.com/s/oswald/v40/TK3IWkUHHAIjg75cFRf3bXL8LICs1_Fv40pKlN4NNSeSASz7FmlWHYg.woff2,https://fonts.gstatic.com/s/oswald/v40/TK3_WkUHHAIjg75cFRf3bXL8LICs18NvsUZiZQ.woff2',
		'font-face': "@font-face{font-family:Oswald;font-style:normal;font-weight:600;font-display:optional;src:url(https://fonts.gstatic.com/s/oswald/v40/TK3IWkUHHAIjg75cFRf3bXL8LICs1_Fv40pKlN4NNSeSASz7FmlWHYg.woff2) format('woff2');unicode-range:U+0000-00FF,U+0131,U+0152-0153,U+02BB-02BC,U+02C6,U+02DA,U+02DC,U+2000-206F,U+2074,U+20AC,U+2122,U+2191,U+2193,U+2212,U+2215,U+FEFF,U+FFFD}@font-face{font-family:Oswald;font-style:normal;font-weight:700;font-display:optional;src:url(https://fonts.gstatic.com/s/oswald/v40/TK3IWkUHHAIjg75cFRf3bXL8LICs1_Fv40pKlN4NNSeSASz7FmlWHYg.woff2) format('woff2');unicode-range:U+0000-00FF,U+0131,U+0152-0153,U+02BB-02BC,U+02C6,U+02DA,U+02DC,U+2000-206F,U+2074,U+20AC,U+2122,U+2191,U+2193,U+2212,U+2215,U+FEFF,U+FFFD}@font-face{font-family:Oswald;font-style:normal;font-weight:400;font-display:optional;src:url(https://fonts.gstatic.com/s/oswald/v40/TK3IWkUHHAIjg75cFRf3bXL8LICs1_Fv40pKlN4NNSeSASz7FmlWHYg.woff2) format('woff2');unicode-range:U+0000-00FF,U+0131,U+0152-0153,U+02BB-02BC,U+02C6,U+02DA,U+02DC,U+2000-206F,U+2074,U+20AC,U+2122,U+2191,U+2193,U+2212,U+2215,U+FEFF,U+FFFD}@font-face{font-family:Oswald;font-style:normal;font-weight:500;font-display:optional;src:url(https://fonts.gstatic.com/s/oswald/v40/TK3_WkUHHAIjg75cFRf3bXL8LICs18NvsUZiZQ.woff2) format('woff2');unicode-range:U+0000-00FF,U+0131,U+0152-0153,U+02BB-02BC,U+02C6,U+02DA,U+02DC,U+2000-206F,U+2074,U+20AC,U+2122,U+2191,U+2193,U+2212,U+2215,U+FEFF,U+FFFD}",
	},
	'Noto+Serif': {
		font: 'https://fonts.gstatic.com/s/notoserif/v16/ga6Law1J5X9T9RW6j9bNdOwzfReecQ.woff2,https://fonts.gstatic.com/s/notoserif/v20/ga6Iaw1J5X9T9RW6j9bNfFcWaA.woff2',
		'font-face': "@font-face{font-family:'Noto Serif';font-style:normal;font-weight:700;font-display:optional;src:url(https://fonts.gstatic.com/s/notoserif/v16/ga6Law1J5X9T9RW6j9bNdOwzfReecQ.woff2) format('woff2');unicode-range:U+0000-00FF,U+0131,U+0152-0153,U+02BB-02BC,U+02C6,U+02DA,U+02DC,U+2000-206F,U+2074,U+20AC,U+2122,U+2191,U+2193,U+2212,U+2215,U+FEFF,U+FFFD}@font-face{font-family:'Noto Serif';font-style:normal;font-weight:400;font-display:optional;src:url(https://fonts.gstatic.com/s/notoserif/v20/ga6Iaw1J5X9T9RW6j9bNfFcWaA.woff2) format('woff2');unicode-range:U+0000-00FF,U+0131,U+0152-0153,U+02BB-02BC,U+02C6,U+02DA,U+02DC,U+2000-206F,U+2074,U+20AC,U+2122,U+2191,U+2193,U+2212,U+2215,U+FEFF,U+FFFD}",
	},
	Cabin: {
		font: 'https://fonts.gstatic.com/s/cabin/v18/u-4i0qWljRw-PfU81xCKCpdpbgZJl6Xvqdns.woff2',
		'font-face': "@font-face{font-family:Cabin;font-style:normal;font-weight:700;font-stretch:100%;font-display:optional;src:url(https://fonts.gstatic.com/s/cabin/v18/u-4i0qWljRw-PfU81xCKCpdpbgZJl6Xvqdns.woff2) format('woff2');unicode-range:U+0000-00FF,U+0131,U+0152-0153,U+02BB-02BC,U+02C6,U+02DA,U+02DC,U+2000-206F,U+2074,U+20AC,U+2122,U+2191,U+2193,U+2212,U+2215,U+FEFF,U+FFFD}@font-face{font-family:Cabin;font-style:normal;font-weight:400;font-stretch:100%;font-display:optional;src:url(https://fonts.gstatic.com/s/cabin/v18/u-4i0qWljRw-PfU81xCKCpdpbgZJl6Xvqdns.woff2) format('woff2');unicode-range:U+0000-00FF,U+0131,U+0152-0153,U+02BB-02BC,U+02C6,U+02DA,U+02DC,U+2000-206F,U+2074,U+20AC,U+2122,U+2191,U+2193,U+2212,U+2215,U+FEFF,U+FFFD}",
	},
};

export default {
	data() {
		return {
			pgData: {},
			sfData: {},
			headConfig: [],
			artType: ['Feature', 'Medical Reference', 'News', 'Feature - Video', 'Tool - RMQ', 'Tool - Slide Show'],
			classObj: {
				onc: ['webmd-onc'],
				blogs: ['webmd-blogs-hc']
			},
			isOncology: true,
		};
	},
	props: {
		chronicId: {
			type: String,
			required: false,
		},
		isDev: {
			type: Boolean,
			default: false,
		},
	},
	methods: {
		/**
		 * All other Site Fronts are using store data to get the required configuration
		 * The purpose of this component is to support Oncology pages Vue conversion as of now
		 * All the content types in the Oncology channels are not VUE. In order to support
		 * both Vue and Non-Vue, still using the JS and CSS and injecting them on the page
		 * Once all the content types moves to Vue then we will revisit this or retire it
		 * @param linksData {object} Object contains js, css and fontAPI URLs for site fronts
		 */
		addConfigToHead() {
			if (this.sfData && _has(this.sfData, 'styleConfig.links')) {
				const linksData = this.sfData.styleConfig.links;
				if (linksData && linksData.length > 0) {
					const loadFontAPI = (linksData[2] && linksData[2].path && linksData[2].path.includes('fonts.googleapis.com'));
					// Do not load fonts for the oncology pages
					if (loadFontAPI && ! this.isOncology) {
						this.headConfig.push('<link rel=\'preconnect\' href=\'https://fonts.gstatic.com\' crossorigin />');
						let fontName = [];
						fontName = linksData[2].path.match(/family=(.*):/)[1];
						this.addFontConfig(fonts[fontName]);
					}
				} else {
					console.log('The style config returned empty object ...', linksData);
				}
			}
		},
		addFontConfig(fontObj) {
			fontObj.font.split(',').forEach((font) => {
				this.headConfig.push(`<link rel="preload" href="${font}" as="font" type="font/woff2" crossOrigin="anonymous" />`);
			});
			this.headConfig.push(`<style>${fontObj['font-face']}</style>`);
		},
		setPcParam() {

			if (this.isOncology) {
				if (_has(window, 'webmd.ads.setPageTarget')) {
					window.webmd.ads.setPageTarget('pc', 'onc');
				}
			}
		}
	},
	computed: {
		getSiteFrontsData() {
			return this.store && this.store.cms.siteFronts;
		},
		getPageData() {
			return this.store.pagedata;
		},
		isArticle() {
			if (_has(this.pgData, 'omniture.s_business_reference')) {
				return this.artType.indexOf(this.busRef) !== -1;
			}
		},
		busRef() {
			if (_has(this.pgData, 'omniture.s_business_reference')) {
				return this.pgData.omniture.s_business_reference;
			}
		},
		imgServerUrl() {
			if (_has(this.pgData, 'omniture.image_server_url')) {
				return this.pgData.omniture.image_server_url;
			}
		},
		isToc() {
			if(this.busRef === 'TOC - Channel' || this.busRef === 'TOC'){
				return true;
			}
			return false;
		},
		isTocDir() {
			if(this.busRef === 'TOC - Topic Dir'){
				return true;
			}
			return false;
		},
		isTocAZ() {
			if (_has(this.pgData, 'omniture.s_publication_source')) {
				if(this.pgData.omniture.s_publication_source === 'WebMD A-Z List' && this.busRef === 'TOC'){
					return true
				}
			}
			return false;
		},
		isOncSubToc() {
			return this.isToc && this.isOncology && this.store.pagedata.omniture.center_id !== '1022';
		},
		isBlog() {
			let checkBlog = false;
			if (_has(this.pgData, 'omniture.center_prefix')) {
				checkBlog = this.pgData.omniture.center_prefix.toLowerCase() === 'blogs';
			}
			return checkBlog;
		},
		isCancer() {
			let center = this.pgData.omniture.center_id;
			let cancerCenters = ['1015', '1019', '1020', '1022', '1023', '1030', '1071', '1075', '1084', '1089', '1097', '1159', '92983' ];

			return cancerCenters.includes(center);
		}
	},
	beforeMount() {
		if (this.isOncology) {
			this.setPcParam();
		}
	},
	created() {
       this.store = useStore(this.$pinia);
		this.sfData = this.getSiteFrontsData;
		this.pgData = this.getPageData;

		if (this.isOncology) {
			this.addConfigToHead();
		}

		if (this.sfData) {
			this.sfData.mode = '';
		}

		if (this.isOncology) {
			if (this.isToc) {
				this.classObj.onc.push('webmd-onc-toc');
			}
			if (this.isOncSubToc) {
				this.classObj.onc.push('webmd-onc-subtoc');
			}
			this.store.cms.updateRootClasses(this.classObj.onc);
			this.store.cms.addToPageData({
				siteFrontsRootStyles: `${this.headConfig.join('\n')}`,
				pageType: 'oncology',
				isOncology: true,
			});

			if (this.isCancer) {
				this.store.cms.addToPageData({
					isCancer: true,
				});
			}
		}
	}
};
</script>
